var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "omegaup-overlay-popup",
    { on: { dismiss: _vm.onHide } },
    [
      _c("transition", { attrs: { name: "fade" } }, [
        _c(
          "form",
          {
            staticClass: "modal-form",
            attrs: { "data-reviewewr-popup": "" },
            on: {
              submit: function ($event) {
                $event.preventDefault()
              },
            },
          },
          [
            _c(
              "div",
              {
                staticClass:
                  "container-fluid d-flex align-items-start flex-column",
              },
              [
                _vm.currentView === _vm.AvailableViews.Content
                  ? [
                      _c(
                        "p",
                        { staticClass: "modal-form__title text-center" },
                        [
                          _vm._v(
                            " " +
                              _vm._s(_vm.T.reviewerNominationFormTitle) +
                              " "
                          ),
                        ]
                      ),
                      _c(
                        "div",
                        { staticClass: "modal-form__field" },
                        [
                          _c("label", { staticClass: "modal-form__label" }, [
                            _vm._v(
                              " " +
                                _vm._s(_vm.T.reviewerNominationQuality) +
                                " "
                            ),
                          ]),
                          _c("br"),
                          _c("omegaup-radio-switch", {
                            attrs: {
                              value: _vm.qualitySeal,
                              "selected-value": _vm.qualitySeal,
                            },
                            on: {
                              "update:value": function ($event) {
                                _vm.qualitySeal = $event
                              },
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          staticClass: "modal-form__field",
                          attrs: { "data-other-tag-input": "" },
                        },
                        [
                          _c("vue-typeahead-bootstrap", {
                            attrs: {
                              data: _vm.publicTags,
                              serializer: _vm.publicTagsSerializer,
                              placeholder: _vm.T.collecionOtherTags,
                            },
                            on: { hit: _vm.addOtherTag },
                          }),
                          _c("br"),
                          _c(
                            "div",
                            { staticClass: "selected-tags-container w-100" },
                            [
                              _c(
                                "ul",
                                { staticClass: "selected-tags-list" },
                                _vm._l(_vm.publicTagsList, function (tag) {
                                  return _c(
                                    "li",
                                    {
                                      key: tag,
                                      staticClass: "selected-tag-chip",
                                    },
                                    [
                                      _c(
                                        "span",
                                        { attrs: { "data-tag-name": "" } },
                                        [_vm._v(_vm._s(_vm.getName(tag)))]
                                      ),
                                      _c(
                                        "button",
                                        {
                                          staticClass:
                                            "selected-tag-remove btn btn-link btn-sm p-0 ml-2 text-danger",
                                          attrs: {
                                            type: "button",
                                            "aria-label": `${
                                              _vm.T.contestEditTagDelete
                                            }: ${_vm.getName(tag)}`,
                                            disabled:
                                              _vm.publicTagsList.length < 2,
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.removeTag(tag)
                                            },
                                          },
                                        },
                                        [
                                          _c("font-awesome-icon", {
                                            attrs: { icon: ["fas", "trash"] },
                                          }),
                                        ],
                                        1
                                      ),
                                    ]
                                  )
                                }),
                                0
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c("div", { staticClass: "modal-form__actions" }, [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-primary",
                            attrs: {
                              "data-review-submit-button": "",
                              type: "submit",
                              disabled: _vm.publicTagsList.length === 0,
                            },
                            on: { click: _vm.onSubmit },
                          },
                          [_vm._v(" " + _vm._s(_vm.T.wordsSend) + " ")]
                        ),
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-secondary",
                            attrs: { type: "button" },
                            on: { click: _vm.onHide },
                          },
                          [_vm._v(" " + _vm._s(_vm.T.wordsCancel) + " ")]
                        ),
                      ]),
                    ]
                  : _vm._e(),
                _vm.currentView === _vm.AvailableViews.Thanks
                  ? [
                      _c("div", { staticClass: "w-100 h-100 h3 text-center" }, [
                        _vm._v(
                          " " + _vm._s(_vm.T.qualityFormThanksForReview) + " "
                        ),
                      ]),
                    ]
                  : _vm._e(),
              ],
              2
            ),
          ]
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }